'use client';

import { c as _c } from "react/compiler-runtime";
import { useRef } from 'react';
import Image from 'next/image';
import Link from 'next/link';
import { motion, useInView } from 'framer-motion';
import useRudderStackAnalytics from '@/hooks/useRudderAnalytics';
import useIsWebview from '@/hooks/use-is-webview';
import { buildPierreWhatsAppUrl } from '@/lib/constants/whatsapp';
export default function Footer() {
  const $ = _c(74);
  const footerRef = useRef(null);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      once: true,
      margin: "-100px"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const isInView = useInView(footerRef, t0);
  const analytics = useRudderStackAnalytics();
  const [isWebView] = useIsWebview();
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      opacity: 0,
      y: 30
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      hidden: t1,
      visible: {
        opacity: 1,
        y: 0,
        transition: {
          duration: 0.6,
          ease: "easeOut"
        }
      }
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const containerVariants = t2;
  let t3;
  if ($[3] !== analytics || $[4] !== isWebView) {
    t3 = (destination, t4) => {
      const category = t4 === undefined ? "social" : t4;
      analytics?.track?.("Outbound Link Clicked", {
        link_destination: destination,
        link_category: category,
        link_location: "lp_footer",
        link_page: "Home",
        platform: !isWebView ? "web" : "app"
      });
    };
    $[3] = analytics;
    $[4] = isWebView;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const handleSocialClick = t3;
  let t4;
  if ($[6] !== analytics) {
    t4 = type => {
      analytics?.track?.("CTA Clicked", {
        cta_name: `download_app_${type}`,
        cta_type: "app",
        cta_location: "lp_footer"
      });
    };
    $[6] = analytics;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const handleDownloadAppClick = t4;
  const t5 = isInView ? "visible" : "hidden";
  let t6;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <div className="flex flex-col gap-4 md:gap-6 lg:gap-[24px] items-start w-full lg:w-auto"><div className="h-[32px] w-[96px] md:h-[39.818px] md:w-[120px] relative shrink-0"><Image src="/images/pierre-logo-navbar.webp" alt="Pierre logo" width={121} height={40} className="object-contain hidden dark:block" priority={true} /><Image src="/images/pierre-logo-navbar-light.png" alt="Pierre logo" width={121} height={40} className="object-contain dark:hidden" priority={true} /></div><p className="font-normal leading-[18px] md:leading-[20px] text-muted-foreground text-[12px] md:text-[13px] lg:text-[14px] uppercase w-full max-w-[346px]">Seu assistente de IA para finanças pessoais. Converse com o seu dinheiro.</p></div>;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== handleSocialClick) {
    t7 = () => handleSocialClick("instagram");
    $[9] = handleSocialClick;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  let t9;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = {
      scale: 1.1,
      rotate: 5
    };
    t9 = {
      duration: 0.2,
      ease: "easeOut"
    };
    $[11] = t8;
    $[12] = t9;
  } else {
    t8 = $[11];
    t9 = $[12];
  }
  let t10;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <Image src="/images/icon-instagram.webp" alt="Instagram" width={24} height={24} className="object-contain" />;
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  let t11;
  if ($[14] !== t7) {
    t11 = <motion.a onClick={t7} whileHover={t8} transition={t9} href="https://instagram.com/pierre.finance.ai" target="_blank" rel="noopener noreferrer" className="size-[32px] md:size-[37.241px] relative shrink-0 flex items-center justify-center" aria-label="Instagram">{t10}</motion.a>;
    $[14] = t7;
    $[15] = t11;
  } else {
    t11 = $[15];
  }
  let t12;
  if ($[16] !== handleSocialClick) {
    t12 = () => handleSocialClick("discord");
    $[16] = handleSocialClick;
    $[17] = t12;
  } else {
    t12 = $[17];
  }
  let t13;
  let t14;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = {
      scale: 1.1,
      rotate: 5
    };
    t14 = {
      duration: 0.2,
      ease: "easeOut"
    };
    $[18] = t13;
    $[19] = t14;
  } else {
    t13 = $[18];
    t14 = $[19];
  }
  let t15;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <Image src="/images/icon-discord.webp" alt="Discord" width={24} height={24} className="object-contain" />;
    $[20] = t15;
  } else {
    t15 = $[20];
  }
  let t16;
  if ($[21] !== t12) {
    t16 = <motion.a onClick={t12} whileHover={t13} transition={t14} href="https://discord.gg/QurJK5p7GJ" target="_blank" rel="noopener noreferrer" className="size-[32px] md:size-[37.241px] relative shrink-0 flex items-center justify-center" aria-label="Discord">{t15}</motion.a>;
    $[21] = t12;
    $[22] = t16;
  } else {
    t16 = $[22];
  }
  let t17;
  if ($[23] !== handleSocialClick) {
    t17 = () => handleSocialClick("whatsapp");
    $[23] = handleSocialClick;
    $[24] = t17;
  } else {
    t17 = $[24];
  }
  let t18;
  let t19;
  let t20;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = {
      scale: 1.1,
      rotate: 5
    };
    t19 = {
      duration: 0.2,
      ease: "easeOut"
    };
    t20 = buildPierreWhatsAppUrl("Ol\xE1, Pierre. Pode me ajudar com o meu dinheiro?");
    $[25] = t18;
    $[26] = t19;
    $[27] = t20;
  } else {
    t18 = $[25];
    t19 = $[26];
    t20 = $[27];
  }
  let t21;
  if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
    t21 = <Image src="/images/icon-whatsapp.webp" alt="WhatsApp" width={24} height={24} className="object-contain" />;
    $[28] = t21;
  } else {
    t21 = $[28];
  }
  let t22;
  if ($[29] !== t17) {
    t22 = <motion.a onClick={t17} whileHover={t18} transition={t19} href={t20} target="_blank" rel="noopener noreferrer" className="size-[32px] md:size-[37.241px] relative shrink-0 flex items-center justify-center" aria-label="WhatsApp">{t21}</motion.a>;
    $[29] = t17;
    $[30] = t22;
  } else {
    t22 = $[30];
  }
  let t23;
  if ($[31] !== t11 || $[32] !== t16 || $[33] !== t22) {
    t23 = <div className="flex gap-1 md:gap-[3px] items-center">{t11}{t16}{t22}</div>;
    $[31] = t11;
    $[32] = t16;
    $[33] = t22;
    $[34] = t23;
  } else {
    t23 = $[34];
  }
  let t24;
  if ($[35] === Symbol.for("react.memo_cache_sentinel")) {
    t24 = <div className="w-[0.776px] h-[12.414px] bg-[var(--color-neutral-foreground-muted)] shrink-0 hidden md:block" />;
    $[35] = t24;
  } else {
    t24 = $[35];
  }
  let t25;
  if ($[36] !== handleSocialClick) {
    t25 = <Link onClick={() => handleSocialClick("terms_of_use", "legal")} href="/privacy-policy" className="font-normal leading-[18px] md:leading-[20px] text-primary dark:text-[rgba(255,255,255,0.7)] text-[12px] md:text-[13px] lg:text-[14px] hover:opacity-80 transition-opacity">TERMOS DE USO</Link>;
    $[36] = handleSocialClick;
    $[37] = t25;
  } else {
    t25 = $[37];
  }
  let t26;
  if ($[38] !== handleSocialClick) {
    t26 = <Link onClick={() => handleSocialClick("pierre_docs", "developers")} href="https://docs.pierre.finance/" target="_blank" className="font-normal leading-[18px] md:leading-[20px] text-primary dark:text-[rgba(255,255,255,0.7)] text-[12px] md:text-[13px] lg:text-[14px] hover:opacity-80 transition-opacity">DESENVOLVEDORES</Link>;
    $[38] = handleSocialClick;
    $[39] = t26;
  } else {
    t26 = $[39];
  }
  let t27;
  if ($[40] === Symbol.for("react.memo_cache_sentinel")) {
    t27 = <div className="w-[0.776px] h-[12.414px] bg-[var(--color-neutral-foreground-muted)] shrink-0 hidden md:block" />;
    $[40] = t27;
  } else {
    t27 = $[40];
  }
  let t28;
  if ($[41] !== t23 || $[42] !== t25 || $[43] !== t26) {
    t28 = <div className="flex flex-wrap gap-4 md:gap-6 lg:gap-[24px] items-center justify-start">{t23}{t24}{t25}{t26}{t27}</div>;
    $[41] = t23;
    $[42] = t25;
    $[43] = t26;
    $[44] = t28;
  } else {
    t28 = $[44];
  }
  let t29;
  if ($[45] !== handleDownloadAppClick) {
    t29 = () => handleDownloadAppClick("ios");
    $[45] = handleDownloadAppClick;
    $[46] = t29;
  } else {
    t29 = $[46];
  }
  let t30;
  if ($[47] === Symbol.for("react.memo_cache_sentinel")) {
    t30 = <Image src="/images/app-store-badge.webp" alt="Baixar na App Store" width={126} height={40} className="object-contain" />;
    $[47] = t30;
  } else {
    t30 = $[47];
  }
  let t31;
  if ($[48] !== t29) {
    t31 = <a onClick={t29} href="https://apps.apple.com/br/app/pierre-controle-de-gastos-ia/id6749781755?l=en-GB" target="_blank" rel="noopener noreferrer" className="w-[110px] h-[35px] md:w-[126px] md:h-[40px] bg-[var(--color-primary-background)] border border-[var(--color-neutral-border)] rounded-[7px] relative overflow-hidden flex items-center justify-center hover:opacity-80 transition-opacity shrink-0">{t30}</a>;
    $[48] = t29;
    $[49] = t31;
  } else {
    t31 = $[49];
  }
  let t32;
  if ($[50] !== handleDownloadAppClick) {
    t32 = () => handleDownloadAppClick("android");
    $[50] = handleDownloadAppClick;
    $[51] = t32;
  } else {
    t32 = $[51];
  }
  let t33;
  if ($[52] === Symbol.for("react.memo_cache_sentinel")) {
    t33 = <Image src="/images/google-play-badge.webp" alt={"Dispon\xEDvel no Google Play"} width={135} height={40} className="object-contain" />;
    $[52] = t33;
  } else {
    t33 = $[52];
  }
  let t34;
  if ($[53] !== t32) {
    t34 = <a onClick={t32} href="https://play.google.com/store/apps/details?id=io.cloudwalk.pierre&pcampaignid=web_share" target="_blank" rel="noopener noreferrer" className="w-[120px] h-[35px] md:w-[135px] md:h-[40px] bg-[var(--color-primary-background)] border border-[var(--color-neutral-border)] rounded-[5px] relative overflow-hidden flex items-center justify-center hover:opacity-80 transition-opacity shrink-0">{t33}</a>;
    $[53] = t32;
    $[54] = t34;
  } else {
    t34 = $[54];
  }
  let t35;
  if ($[55] !== t31 || $[56] !== t34) {
    t35 = <div className="flex gap-2 md:gap-[8px] items-center flex-wrap">{t31}{t34}</div>;
    $[55] = t31;
    $[56] = t34;
    $[57] = t35;
  } else {
    t35 = $[57];
  }
  let t36;
  if ($[58] !== t28 || $[59] !== t35) {
    t36 = <div className="flex flex-col gap-4 md:gap-6 lg:gap-[24px] items-start w-full lg:w-auto">{t6}{t28}{t35}</div>;
    $[58] = t28;
    $[59] = t35;
    $[60] = t36;
  } else {
    t36 = $[60];
  }
  let t37;
  let t38;
  if ($[61] === Symbol.for("react.memo_cache_sentinel")) {
    t37 = {
      scale: 1.05,
      y: -4,
      boxShadow: "0 8px 24px rgba(0, 0, 0, 0.2)"
    };
    t38 = {
      duration: 0.3,
      ease: "easeOut"
    };
    $[61] = t37;
    $[62] = t38;
  } else {
    t37 = $[61];
    t38 = $[62];
  }
  let t39;
  if ($[63] === Symbol.for("react.memo_cache_sentinel")) {
    t39 = <motion.div whileHover={t37} transition={t38} data-cursor-text="escaneie para baixar o app" className="hidden lg:block w-full max-w-[200px] md:max-w-[240px] lg:size-[240px] aspect-square relative rounded-[24px] overflow-hidden mx-auto lg:mx-0 transition-shadow cursor-pointer"><Image src="/images/qr-code.svg" alt="QR Code para download do app Pierre" fill={true} className="object-cover" sizes="240px" /></motion.div>;
    $[63] = t39;
  } else {
    t39 = $[63];
  }
  let t40;
  if ($[64] !== t36) {
    t40 = <div className="w-full flex flex-col lg:flex-row items-start lg:items-end justify-between gap-8 md:gap-10 lg:gap-0">{t36}{t39}</div>;
    $[64] = t36;
    $[65] = t40;
  } else {
    t40 = $[65];
  }
  let t41;
  if ($[66] === Symbol.for("react.memo_cache_sentinel")) {
    t41 = <div className="w-full h-[0.776px] bg-[rgba(158,158,158,0.3)] shrink-0" />;
    $[66] = t41;
  } else {
    t41 = $[66];
  }
  let t42;
  if ($[67] === Symbol.for("react.memo_cache_sentinel")) {
    t42 = <div className="w-full"><p className="font-normal leading-[18px] md:leading-[20px] text-[var(--color-neutral-foreground-muted)] text-[11px] md:text-[12px] lg:text-[14px] w-full md:w-auto">Nosso atendimento técnico e operacional é realizado exclusivamente de segunda a sexta, das 10h às 16h, através dos canais: chat pelo aplicativo e e-mail:{" "}<a href="mailto:ajuda@pierre.finance" className="underline hover:opacity-80 transition-opacity">ajuda@pierre.finance</a>.</p></div>;
    $[67] = t42;
  } else {
    t42 = $[67];
  }
  let t43;
  if ($[68] === Symbol.for("react.memo_cache_sentinel")) {
    t43 = <div className="w-full flex flex-col md:flex-row items-start md:items-center justify-between gap-3 md:gap-4 lg:gap-0"><p className="font-normal leading-[18px] md:leading-[20px] text-[var(--color-neutral-foreground-muted)] text-[11px] md:text-[12px] lg:text-[14px] uppercase w-full md:w-auto">© 2025 Pierre - Assistente de IA Financeiro. Todos os direitos reservados.</p></div>;
    $[68] = t43;
  } else {
    t43 = $[68];
  }
  let t44;
  if ($[69] !== t40) {
    t44 = <div className="w-full container flex flex-col gap-8 md:gap-10 lg:gap-[40px]">{t40}{t41}{t42}{t43}</div>;
    $[69] = t40;
    $[70] = t44;
  } else {
    t44 = $[70];
  }
  let t45;
  if ($[71] !== t44 || $[72] !== t5) {
    t45 = <motion.footer data-legal-webview-hidden={true} ref={footerRef} variants={containerVariants} initial="hidden" animate={t5} className="w-full flex flex-col items-center px-4 md:px-8 lg:px-[40px] py-12 md:py-16 lg:py-[96px]">{t44}</motion.footer>;
    $[71] = t44;
    $[72] = t5;
    $[73] = t45;
  } else {
    t45 = $[73];
  }
  return t45;
}